export enum DATA_QA {
  ROOT = 'csv-dialpad-property-select',
}
